import { CsiImage, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";
import imageLS from "./LandscapeSmallImage.jpg";
import imageLT from "./LandscapeThumbnail.jpg";
import imagePS from "./PortraitSmallImage.jpg";
import imagePT from "./PortraitThumbnail.jpg";

export default () => {
	return (
		<CssColumnGrid columns={4}>
			<Text semiBold text="landscape (small)" />
			<Text semiBold text="landscape (large)" />
			<Text semiBold text="portrait (small)" />
			<Text semiBold text="portrait (large)" />
			<CsiImage size="smallest" src={imageLT} />
			<CsiImage size="smallest" src={imageLS} />
			<CsiImage size="smallest" src={imagePT} />
			<CsiImage size="smallest" src={imagePS} />
		</CssColumnGrid>
	);
};